import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import swal from 'sweetalert';
import logo1 from "../../../../Image/aboutimg.png";
import { BASE_URL } from '../../../../insightConfig/insightConfig';

function NeetAllSubjectsPaymentModal({ setOpen, Amount, orders, setPaymentProccessingModal, setPaymentSuccessModal, setTransactionId }) {
    const navigate = useNavigate();
    const EmailId = localStorage.getItem('authtoken');
    const [userpay, setUserpay] = useState('');
    const userDetail = userpay[0]

    useEffect(() => {
        if (!EmailId) return;
        axios.get(`${BASE_URL}/studentdashboard`)
            .then(response => {
                setUserpay(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }, [EmailId]);

    const saveOrderDetails = async (transactionid) => {
        let orderDetails = orders.map(order => ({
            SubjectID: order.Sn,
            amount: Math.ceil(order.Price - (order.Price * order.Discount / 100)),
            TestCount: order.TestCount,
            EmailId: EmailId,
            transactionid,
            Section: order.Section,
        }));
        try {
            // Save each order individually using existing endpoint
            for (const orderDetail of orderDetails) {
                await axios.post(`${BASE_URL}/neet/user/saveOrder`, orderDetail);
            }
            setPaymentProccessingModal(false);
            setPaymentSuccessModal(true);
            setTransactionId(transactionid);
        } catch (error) {
            console.log(error);
        }
    }

    const verifyPayment = async (razorpay_order_id, razorpay_payment_id, razorpay_signature) => {
        const response = await axios.post(BASE_URL + '/paymentVarification', { razorpay_order_id, razorpay_payment_id, razorpay_signature });
        return response.data.success;
    }

    const handlePayment = async () => {
        setOpen(false);
        const response = await axios.post(BASE_URL + '/checkout', { amount: Number(100) });
        var options = {
            key: 'rzp_live_MiLEU5w3lLxTXm',
            amount: response.data.order.amount,
            currency: "INR",
            name: "Insight Edutech Pvt...",
            description: "Test Transaction",
            image: logo1,
            order_id: response.data.order.id,
            handler: (res) => {
                const isVerified = verifyPayment(res.razorpay_order_id, res.razorpay_payment_id, res.razorpay_signature);
                if (isVerified) {
                    setPaymentProccessingModal(true);
                    setTimeout(() => {
                        saveOrderDetails(res.razorpay_payment_id);
                    }, 1000);
                } else {
                    swal("Invalid Payment Signature!", "Please Try Again", { icon: "error" });
                }
            },
            prefill: {
                name: userDetail?.FirstName || '',
                email: userDetail?.EmailId || '',
                contact: userDetail?.MobileNo || '',
            },
            notes: {
                address: "Razorpay Corporate Office"
            },
            theme: {
                color: "#005bf2"
            }
        };
        const rzpay = new window.Razorpay(options);
        rzpay.open();
    }

    return (
        <>
            <div className="modal-content text-center p-3">
                <div className="modal-header">
                    <h5 className="modal-title">Terms & Conditions</h5>
                    <button type="button" onClick={() => setOpen(false)} className='btn-close' aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    <p>1. Details of a Student: Every student subscribing to any course has to fill/upload the required details on his/her 'Profile' page such as a passport size photo, ID Proof, Address proof, etc. in compliance with the KYC (Know your Customer) requirements mandated by the management of the institute and the regulatory authorities.</p>
                    <Link to="/terms-and-conditions" target='_blank' className='list-group-item fw-bold py-2 text-orange'>Read More...</Link>
                </div>
                <div className="d-grid gap-2">
                    <button type="button" onClick={handlePayment} className="btn btn-primary py-3 my-1 fw-bold bg-pureorange proceed-btn">Proceed</button>
                </div>
            </div>
        </>
    );
}

export default NeetAllSubjectsPaymentModal;
